import env from '@travel/env';

export { RAT_PAGE_TYPE_OBJ, ratPropsToParams } from '@travel/traveler-core/constants/ratAnalytics';

export const RAT_ACCOUNT_ID = Number(env('UNIVERSAL_RAT_ACCOUNT_ID'));
export const RAT_SERVICE_ID = Number(env('UNIVERSAL_RAT_SERVICE_ID'));
